import {Box, Typography} from '@mui/material';
import './ai-talk.scss';

export const AiTalk = (props: {content: string}) => {
  return (
    <Box className="ai-talk">
      <Typography variant="body1" gutterBottom>
        {props.content}
      </Typography>
    </Box>
  );
};
